import MarketBuzzManagement from '../../../components/screens/admin/market-buzz-management/MarketBuzzManagement';

const MarketBuzzManagementContainer = () => {
  return <MarketBuzzManagement />;
};

export default MarketBuzzManagementContainer;
